const MobileMenu = () => {

    // Slide down submenus (on open)
    const slideDown = element => element.style.height = `${element.scrollHeight}px`;

    // Slide up submenus (on close)
    const slideUp = element => element.style.height = '0px';

    // Fetch all mobile menu items
    let items = document.querySelectorAll('.mobile-menu__item--parent');

    // Loop through all menu items that contain submenus
    Array.from( items ).forEach( item => {

        // Locate the arrow wrapper which will essentially be the trigger for this menu
        // opening and closing
        let arrow = item.querySelector('.mobile-menu__arrow-wrap');

        // If we have an arrow, proceed
        if (typeof arrow != "undefined" && arrow != null) {
            
            // Add event listened for when the user clicks on the <li>
            arrow.addEventListener('click', e => {
                
                // Fetch the corresponding submenu beneath this main parent <li>
                let submenu = item.querySelector('.mobile-menu__sub-menu');

                // If the <li> already has the active class
                if (item.matches('.mobile-menu__item--active')) {
                    // Remove the active class
                    item.classList.remove('mobile-menu__item--active');
                    // Close the submenu
                    slideUp(submenu);
                } else {
                    // Add the active class
                    item.classList.add('mobile-menu__item--active');
                    // Open the submenu
                    slideDown(submenu);
                }
            });
        }
    });
}

export default MobileMenu;